import api from "./api";

export interface StaffDeliveryItem {
  id: string;
  order_number: string;
  customer_name: string;
  customer_phone: string;
  customer_location_note?: string | null;
  customer_address?: string | null;
  customer_latitude?: number | null;
  customer_longitude?: number | null;
  delivery_address: string | null;
  delivery_latitude: number | null;
  delivery_longitude: number | null;
  total_amount: number;
  notes: string | null;
  item_count: number;
  validated_at: string | null;
  updated_at: string;
  items: Array<{
    id: string;
    order_id: string;
    inventory_item_id: string;
    quantity: number;
    unit_price: number;
    line_total: number;
    product_name: string;
  }>;
}

export interface StaffDeliveryListResponse {
  items: StaffDeliveryItem[];
}

/** Reason codes for reporting a delivery issue (Story 8-3). */
export type StaffDeliveryIssueReason =
  | "customer_not_available"
  | "wrong_address"
  | "refused_delivery"
  | "other";

/**
 * List deliveries assigned to current staff user (Story 8-2).
 */
export async function listStaffDeliveries(): Promise<StaffDeliveryListResponse> {
  const response = await api.get<StaffDeliveryListResponse>("/staff/deliveries");
  return response.data;
}

/**
 * Mark an assigned delivery as delivered (Story 8-3).
 * Returns full order detail; order will no longer appear in staff deliveries list.
 */
export async function completeDelivery(orderId: string, notes?: string | null): Promise<unknown> {
  const body = notes?.trim() ? { notes: notes.trim() } : {};
  const response = await api.patch(`/staff/deliveries/${orderId}/complete`, body);
  return response.data;
}

/**
 * Report a delivery issue for an assigned order (Story 8-3).
 * Order remains validated; a note is added for admin.
 */
export async function reportIssue(
  orderId: string,
  reason: StaffDeliveryIssueReason,
  notes?: string | null
): Promise<unknown> {
  const response = await api.post(`/staff/deliveries/${orderId}/issue`, {
    reason,
    notes: notes?.trim() || undefined,
  });
  return response.data;
}
